import { PartImage } from "../SpareParts/BomItemDetails";

export enum AvaibilityType {
    Green = "available",
    Yellow = "planned",
    Orange = "partially available",
    Red = "not available",
    Grey = "none"
}

export type BasketItem = {
    rowId: string,
    code: string,
    manufacturerCompanyCode: string,
    partDescription: string;
    qty: number,
    uom: string,
    note: string,
    navContext?: string,
    customDescription: string,
    currency: string,
    netTotalPrice?: number,
    grossUnitPrice?: number,
    discount: string,
    warningMinQty: boolean,
    warningPackageQty: boolean,
    minOrderQty?: number;
    packageQuantity?: number;
    replacedCode: string,
    availabilityStatus?: AvaibilityType|undefined,
    hidePrice: boolean;
    images: PartImage[];
}

export type BasketItemDTO = {
    id?: number,
    rowId?: string,
    basketId?: number,
    code?: string,
    replacedCode?: string,
    manufacturerCompanyCode?: string,
    qty?: number,
    navContext?: string,
}